module.exports = __webpack_public_path__ + "static/img/opcionA.af5afcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/opcionA.png
// module id = b7Or
// module chunks = 1